import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgPants = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 53.79 100.01",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fff;}" }) }),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "16.24 97.86 1.31 97.86 1.31 39 1.33 1.74 13.51 1.39 20.93 1.04 26.75 1.39 52.53 1.21 52.71 10.75 52.71 98.86 37.7 99.21 32.23 59.3 26.58 30.17 26.93 20.63 27.11 26.99 16.24 97.86"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M52.73.01H1.07C.48.01,0,.49,0,1.08l.14,97.86c0,.59.48,1.07,1.07,1.07h15.06c.53,0,.98-.39,1.05-.91l9.56-64.31,9.6,64.31c.08.52.53.91,1.05.91h15.06c.59,0,1.07-.48,1.07-1.07l.13-97.87c0-.59-.48-1.07-1.07-1.07h0ZM41.03,13.49h10.63l-.02,11.78c-5.94-.54-10.61-5.55-10.61-11.64,0,0,0-.14,0-.14ZM43.98,2.15h7.68v9.2h-7.68V2.15ZM33.31,2.15h8.54v9.2h-8.54V2.15ZM22.63,2.15h8.54v9.2h-8.54s0-9.2,0-9.2ZM11.96,2.15h8.54v9.2h-8.54V2.15ZM2.15,13.49h10.85v.14c0,6.16-4.79,11.22-10.83,11.66,0,0-.02-11.8-.02-11.8ZM2.14,2.15h7.68v9.2H2.14V2.15ZM38.46,97.88L27.94,27.46v-6.49c0-.59-.48-1.07-1.07-1.07s-1.07.48-1.07,1.07v6.49l-10.46,70.41H2.27l-.11-70.44c7.22-.45,12.96-6.46,12.96-13.8v-.14h23.76v.14c0,7.26,5.62,13.23,12.75,13.78l-.11,70.46h-13.07,0Z" })
	]
});
export default SvgPants;
